module.exports = __webpack_public_path__ + "868fb770.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/ic_desktop.png
// module id = 1196
// module chunks = 0 1 2